"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optional = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var optional = exports.optional = function optional(Comp) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Comp ? _react2.default.createElement(Comp, props) : null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/util.js
// module id = 47
// module chunks = 0